import {
    GET_PERMISSIONS_SUCCESS,
    CREATE_PERMISSION_SUCCESS,
    UPDATE_PERMISSION_SUCCESS,
    INVITE_PERMISSION_SUCCESS
} from './constants';

const initialState = {}; // Ensure initial state is an array

const permissions = (state = initialState, action) => {
    switch (action.type) {
        case GET_PERMISSIONS_SUCCESS:
            return { ...action.permissions };
        case CREATE_PERMISSION_SUCCESS:
            return { ...action.permissions };
        case UPDATE_PERMISSION_SUCCESS:
            return { ...action.permissions };
        case INVITE_PERMISSION_SUCCESS:
            return { ...action.permissions };
        default:
            return state;
    }
};

export default permissions;
